import en from "@/locales/fragments/staff-employees.en.json";
import ar from "@/locales/fragments/staff-employees.ar.json";

// Keep the complete prototype (and its full-flow dictionary) out of the
// application's initial bundle. Only Staff screen chunks need that authority.
export function staffNavigationText(value:string,rtl:boolean) {
  if(!rtl)return value;
  if(value==="Attendance")return "الحضور";
  if(value==="⌕  Find a person · name, mobile, code")return ar.staff.personSearch;
  if(value==="CHICKIN WORX")return "تشيكن ووركس";
  if(value==="Positions")return "المسميات";
  if(value==="Bonuses")return "الحوافز";
  if(value==="Certificates")return "الشهادات";
  if(value==="Certificates overview")return "نظرة عامة على الشهادات";
  const key=Object.entries(en.staff).find(([,text])=>text===value)?.[0];
  return key?(ar.staff as Record<string,string>)[key]||value:value;
}
